import styles from "./RecordManagementPolicyPage.module.css";

const RecordManagementPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>ΠΟΛΙΤΙΚΗ ΔΙΑΧΕΙΡΙΣΗΣ ΑΡΧΕΙΩΝ</h1>
      <p>
        Βασική αρχή και δέσμευση της Εταιρείας THE RECORDS HUB S.A. είναι η
        σωστή διαχείριση των αρχείων της καθώς και των αρχείων των πελατών της
        ώστε να ικανοποιούνται οι ανάγκες και προσδοκίες τους. Η Διαχείριση των
        Αρχείων (ΣΔΑ) γίνεται μέσα από την εφαρμογή ενός Συστήματος Διαχείρισης
        Αρχείων σύμφωνα με το πρότυπο ISO 30301:2019.
      </p>

      <h2>Το πεδίο εφαρμογής της εταιρείας είναι:</h2>
      <ul>
        <li>
          ΑΣΦΑΛΗΣ ΨΗΦΙΟΠΟΙΗΣΗ, ΦΥΛΑΞΗ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ ΤΩΝ ΠΕΛΑΤΩΝ ΤΗΣ
          ΕΤΑΙΡΕΙΑΣ, ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ ΣΕ ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ
        </li>
        <li>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΤΩΝ ΑΡΧΕΙΩΝ</li>
        <li>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ GDPR/DPO</li>
        <li>ΑΣΦΑΛΗΣ ΚΑΤΑΣΤΡΟΦΗ ΑΡΧΕΙΩΝ</li>
      </ul>

      <h2>
        Ο Σχεδιασμός του ΣΔΑ διεξάγεται σύμφωνα με τους ακόλουθους στόχους:
      </h2>
      <ul>
        <li>Συμμόρφωση με τα χαρακτηριστικά ενός σωστού ΣΔΑ.</li>
        <li>
          Διαλειτουργικότητα για την υποστήριξη της αλληλεπίδρασης με άλλα
          συστήματα και ευέλικτη προσέγγιση όσον αφορά τη χρήση των αρχείων.
        </li>
        <li>Ευκολία στη χρήση των αρχείων και επαναχρησιμοποίηση τους.</li>
        <li>
          Ετοιμότητα για τεχνολογικές ή επιχειρηματικές αλλαγές, όπως
          αναβαθμίσεις του συστήματος ή διοικητική αναδιάρθρωση.
        </li>
        <li>
          Ετοιμότητα για επιχειρηματική συνέχεια και συνέχιση της επιχείρησης σε
          περίπτωση απροσδόκητων αναταραχών.
        </li>
        <li>
          Δημιουργία και σύλληψη αρχείων, τα οποία αποδεικνύουν την
          επιχειρησιακή δραστηριότητα της εταιρείας.
        </li>
        <li>
          Δημιουργία διαδικασιών και πολιτικών οι οποίες προστατεύουν την
          αυθεντικότητα, εγκυρότητα και αξιοπιστία των αρχείων.
        </li>
        <li>
          Δημιουργία αρχείων που χαρακτηρίζονται από αυθεντικότητα, αξιοπιστία,
          ακεραιότητα και χρηστικότητα.
        </li>
      </ul>

      <h2>
        Για την επιτυχία των παραπάνω στόχων το ΣΔΑ της εταιρείας βασίζεται στις
        παρακάτω αρχές:
      </h2>
      <ul>
        <li>
          Θέσπιση Πολιτικών και Αρμοδιοτήτων για την παρακολούθηση της
          αποτελεσματικότητας του ΣΔΑ.
        </li>
        <li>
          Επαναλαμβανόμενη ανάλυση του επιχειρηματικού πλαισίου και
          προσδιορισμός των απαιτήσεων του ΣΔΑ.
        </li>
        <li>
          Δέσμευση για συνεχή βελτίωση του Συστήματος Διαχείρισης Αρχείων.
        </li>
        <li>Έλεγχος των αρχείων.</li>
        <li>
          Εφαρμογή Διαδικασιών για τη Δημιουργία, Καταγραφή και Διαχείριση των
          Αρχείων.
        </li>
        <li>
          Τα αρχεία (ανεξαρτήτως μορφής και δομής) είναι έγκυρες αποδείξεις της
          επιχείρησης όταν χαρακτηρίζονται από γνησιότητα, αξιοπιστία,
          ακεραιότητα και ευχρηστία.
        </li>
        <li>
          Το περιεχόμενο των αρχείων και των μεταδεδομένων περιγράφει το
          πλαίσιο, την δομή των εγγράφων και τη διαχείριση.
        </li>
        <li>
          Οι αποφάσεις για τη δημιουργία, καταγραφή και διαχείριση των εγγράφων
          βασίζονται στην ανάλυση και αξιολόγηση των κινδύνων μέσα στο πλαίσιο
          λειτουργίας της επιχείρησης.
        </li>
      </ul>

      <h2>Το σύστημα διαχείρισης αρχείων της εταιρείας:</h2>
      <ul>
        <li>
          Συλλαμβάνει συστηματικά αρχεία εντός του πεδίου της επιχειρηματικής
          δραστηριότητας που υποστηρίζει.
        </li>
        <li>
          Λειτουργεί ως η κύρια πηγή έγκυρων πληροφοριών σχετικά με ενέργειες
          που τεκμηριώνονται στα αρχεία.
        </li>
        <li>
          Επιτρέπει τη συμμετοχή οποιωνδήποτε εξουσιοδοτημένων αντιπροσώπων.
        </li>
        <li>Παρουσιάζει αρχεία σε χρήσιμη μορφή.</li>
        <li>Υποστηρίζει την έγκαιρη πρόσβαση.</li>
        <li>
          Προστατεύει τα αρχεία από μη εξουσιοδοτημένη χρήση, αλλοίωση, απόκρυψη
          ή καταστροφή.
        </li>
        <li>Αποθηκεύει τα αρχεία για όσο χρόνο χρειάζονται.</li>
        <li>
          Παρέχει μηχανισμούς, όπου είναι απαραίτητο, για την εισαγωγή (ή με
          άλλο τρόπο ενσωμάτωση) αρχείων και δεδομένων για την εγγραφή στο
          σύστημα ή για την εξαγωγή τους από το ένα σύστημα στο άλλο.
        </li>
        <li>Επιτρέπει τη διεξαγωγή ενεργειών σε αρχεία.</li>
      </ul>

      <h2>Χαρακτηριστικά αρχείων</h2>

      <h3>Αυθεντικότητα</h3>
      <p>
        Ένα αυθεντικό αρχείο είναι αυτό που μπορεί να αποδείξει:
        <ul>
          <li>Το σκοπό του</li>
          <li>
            Έχει δημιουργηθεί ή αποστέλλεται από τον αντιπρόσωπο που φέρεται ότι
            το δημιούργησε ή το έστειλε.
          </li>
          <li>Έχει δημιουργηθεί ή αποστέλλεται όταν πρέπει.</li>
        </ul>
      </p>
      <p>
        Οι κανονισμοί της εταιρείας, οι πολιτικές και οι διαδικασίες ελέγχουν τη
        δημιουργία αρχείων για να διασφαλίζεται η αυθεντικότητα τους. Τα άτομα
        τα οποία έχουν δικαίωμα να δημιουργούν αρχεία είναι καθορισμένα από τη
        Διοίκηση.
      </p>

      <h3>Αξιοπιστία</h3>
      <p>
        Αξιόπιστο αρχείο είναι:
        <ul>
          <li>
            Αυτό του οποίου το περιεχόμενο μπορεί να είναι έμπιστο ως πλήρη και
            ακριβή αναπαράσταση των συναλλαγών, των δραστηριοτήτων ή των
            γεγονότων.
          </li>
          <li>
            Αυτό από το οποίο μπορεί να εξαρτηθεί κατά τη διάρκεια
            μεταγενέστερων συναλλαγών ή δραστηριοτήτων.
          </li>
        </ul>
      </p>
      <p>
        Τα αρχεία δημιουργούνται τη στιγμή που χρειάζονται ή αμέσως μετά, από τα
        άτομα που έχουν άμεση γνώση των συστημάτων ή από συστήματα που
        χρησιμοποιούνται συνήθως για τη διεξαγωγή της υπηρεσίας.
      </p>

      <h3>Ακεραιότητα</h3>
      <p>
        Το αρχείο που χαρακτηρίζεται από ακεραιότητα είναι πλήρες και
        αναλλοίωτο. Επίσης, προστατεύεται από μη εξουσιοδοτημένα άτομα. Οι
        πολιτικές και οι διαδικασίες για τη διαχείριση των αρχείων καθορίζουν
        ποιες προσθήκες ή σχολιασμοί μπορούν να γίνουν σε ένα αρχείο μετά τη
        δημιουργία του, υπό ποιες συνθήκες επιτρέπονται οι εν λόγω προσθήκες ή
        σχολιασμοί και ποιος είναι εξουσιοδοτημένος να τις κάνει. Όλες οι
        εγκεκριμένες τροποποιήσεις σε αρχεία (σχολιασμός, προσθήκη ή διαγραφή)
        αναφέρονται και καταγράφονται.
      </p>

      <h3>Χρηστικότητα</h3>
      <p>
        Όλα τα χρήσιμα αρχεία είναι εύκολο να εντοπισθούν, να ανακτηθούν και να
        ερμηνευτούν εντός ενός χρονικού πλαισίου καθορισμένου από τη Διοίκηση.
      </p>
      <p>
        Τα αρχεία συνδέονται με την επιχειρηματική διαδικασία και την ανάγκη που
        προέκυψε για να δημιουργηθούν.
      </p>
      <p>
        Τα δεδομένα των αρχείων υποστηρίζουν πληροφορίες που απαιτούνται για την
        ανάκτηση στοιχείων και πληροφοριών.
      </p>
      <p>
        Το σύστημα διαχείρισης αρχείων της εταιρείας περιλαμβάνει στοιχεία που
        συνδυάζονται με τέτοιο τρόπο ώστε να ικανοποιούνται όλες οι απαιτήσεις
        για την αναγνώριση και την προστασία των αρχείων.
      </p>
    </div>
  );
};

export default RecordManagementPolicyPage;
